import React from 'react';
import { useForm } from 'react-hook-form';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { Checkbox } from '../../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { useDeleteGoalMutation } from '../../../../api/useDeleteGoalMutation';
import { Alert } from '../../../../../../CommonComponents/OPL/Alert/Alert';
import { EstatePlanningGoalData } from '../../EstatePlanning.meta';

const FORM_ID = 'delete-estate-planning-goal--form';
export const HEADER_ID = 'delete-estate-planning-goal--modal-header';

interface FormValues {
  keepEstatePlanningDocuments: boolean;
}

interface Props {
  clientId: string;
  goalId: string;
  onClose(): void;
  data: EstatePlanningGoalData;
}

export const DeleteEstatePlanningGoal = ({
  clientId,
  goalId,
  data: { hasEstatePlanningDocuments: hasDocuments },
  onClose,
}: Props) => {
  const { register, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      keepEstatePlanningDocuments: false,
    },
  });

  const {
    mutateAsync: deleteGoalMutation,
    isLoading: isDeletingGoal,
    error: deleteGoalError,
  } = useDeleteGoalMutation({ clientId });

  const onSubmit = async ({ keepEstatePlanningDocuments }: FormValues) => {
    try {
      await deleteGoalMutation({
        clientId,
        goalId,
        deleteEstatePlanningDocuments: hasDocuments ? !keepEstatePlanningDocuments : undefined,
      });

      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: HEADER_ID }}
    >
      <ModalHeader as="h2" id={HEADER_ID}>
        Are you sure you want to remove this goal?
      </ModalHeader>

      {deleteGoalError && (
        <Alert message={deleteGoalError.message} variant="error" mb="16" mx="24" />
      )}

      <ModalBody as="form" id={FORM_ID} onSubmit={handleSubmit(onSubmit)}>
        {hasDocuments ? (
          <Checkbox {...register('keepEstatePlanningDocuments')}>
            Keep estate planning documents in the document vault
          </Checkbox>
        ) : (
          'This action cannot be undone.'
        )}
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button type="submit" isLoading={isDeletingGoal} form={FORM_ID} variant="error" ml="8">
          Remove Goal
        </Button>
      </ModalFooter>
    </Modal>
  );
};
